import { render, staticRenderFns } from "./SolTodas.vue?vue&type=template&id=789b0508&scoped=true&"
import script from "./SolTodas.vue?vue&type=script&lang=js&"
export * from "./SolTodas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789b0508",
  null
  
)

export default component.exports